import { graphql } from 'parkdepot-shared/gql'

const GET_ERRORFLOW_PRICE = graphql(`
    query GetErrorflowPrice(
        $lot_id: String!
        $plate: String!
        $country: String!
        $start_date: timestamptz!
        $end_date: timestamptz
        $selected_parking_tariff: String
        $parking_context_uuid: String
    ) {
        b2c_get_errorflow_price(
            lot_id: $lot_id
            plate: $plate
            country: $country
            start_date: $start_date
            end_date: $end_date
            selected_parking_tariff: $selected_parking_tariff
            parking_context_uuid: $parking_context_uuid
        ) {
            order {
                order_id
                plate
                start_date
                end_date
                status
                invoice_available
            }
            price {
                currency
                vat_rate
                price_valid_until
                parking_price
                illegal_parking_price
                discounted_parking_price
                applied_discount
                billable
                billable_start
                billable_end
                payment_deadline
            }
            lot {
                lot_id
                name
                address
                lot_type
                lot_tariffs
                sv_lot_type
                discount_types
                visible_toleration_time
                arrival_detection_time
                longitude
                latitude
            }
            parking_contexts {
                uuid
                vehicle_type
            }
            scanned_codes
        }
    }
`)

export default GET_ERRORFLOW_PRICE
